import React from 'react';
import Highlighter from 'react-highlight-words';
import { useStyles } from '@tcs/client-portal-common/components/molecules/Table/style';
interface CellProps {
  value: string;
  search: string;
}

const HighlightableCell = ({ value, search }: CellProps) => {
  const classes = useStyles({});

  return (
    <div className={classes.baseCell} title={value}>
      <Highlighter
        searchWords={[search]}
        textToHighlight={value}
        highlightClassName={classes.highlighted}
        highlightTag="span"
      />
    </div>
  );
};

export default HighlightableCell;
